import i18next from '../i18n/config';

export default class RegExpUtil {
  static validateRegExpForError = (regexStr) => {
    try {
      const regexp = new RegExp(regexStr);
      if (Object.prototype.toString.call(regexp) !== '[object RegExp]') {
        throw new Error(i18next.t("error.invalid_regex_object", { value: regexStr }));
      }

      return null;
    } catch (e) {
      return e?.message || i18next.t("error.unknown_error");
    }
  };

  static isValidRegExp = (regexStr) => this.validateRegExpForError(regexStr) === null;

  static isRegExpLike = (text) => {
    if (!text) return false;
    return ['*', '?', '+', '{', '}', '(', ')', '|', '^', '$', '.', '[', ']', '\\'].some(char => text.includes(char));
  };

  // @see https://github.com/facebook/react/issues/3386#issuecomment-78605760
  static replacePatternToComponent = (text, pattern, callback) => {
    if (!text) {
      return;
    }

    let splitText = text.split(pattern);
    for (var i = 1; i < splitText.length; i += 2) {
      splitText[i] = callback(splitText[i]);
    }
    return splitText;
  };

  static replacePattern = (text, pattern, callback) => this.replacePatternToComponent(text, pattern, callback).join('');
}
